
export class CreditCard
{
  id: number;
  firstName: string;
  lastName: string;
  nickName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  creditCardNumber: string;
  expirationMonth: number;
  expirationYear: number;
  useThis: boolean;
  paymentTypeId: number;
  paymentType: string;
  vaultID:string;
  alnVaultID:string;
  courtVaultID:string;
  vaultsDTOs: any[];
}
